import { gql } from 'graphql-request';

export interface DeleteCompanyTabQueryResponse {
  deleteCompanyTab: {
    status: string;
  };
}

export const DELETE_COMPANY_TAB_QUERY = gql`
  mutation DeleteCompanyTab($uid: Uid!) {
    deleteCompanyTab(uid: $uid) {
      status
    }
  }
`;
